import type { ScenarioUpdate } from '../models'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { scenarioNodeSchema } from './scenarioNodeSchema'
import { z } from 'zod'

export const scenarioUpdateSchema = z.object({
  name: z.string().optional(),
  version_name: z.string().nullable().nullish(),
  nodes: z.array(z.lazy(() => scenarioNodeSchema)),
}) as unknown as ToZod<ScenarioUpdate>

export type ScenarioUpdateSchema = ScenarioUpdate